var exports = {
  "kL": "x31de4314--7c61e4--container",
  "Qs": "x31de4314--7c61e4--content",
  "uQ": "x31de4314--7c61e4--text-group",
  "r7": "x31de4314--7c61e4--image-slot",
};

module.exports = exports;
